// export enum FileType {
//   Image,
//   Video,
// }
export enum FileType {
  Image,
  Video,
  Text,
  ImageVideo,
}
// 用于UploaderNext
export enum MediaType {
  Image = 1,
  Video = 2,
  Text = 3,
  ImageVideo = 4,
}
